import {getAppUrls} from './Config';

// Where to send a user when the kiosk isn't available, or when they exit it. Mirrors the shared
// getAppUrls().HOME_URL so the home destination is defined in exactly one place and follows
// the domain the kiosk is served on.
export const getWelbeeHomeUrl = (host) => getAppUrls(host).HOME_URL;

// A kiosk runs on an unauthenticated, shared device, so the school's URN is the only identity
// check. A school must therefore have a URN on record to run a kiosk — without one (or before the
// school has loaded) the kiosk is not available and the user is sent to Welbee home.
export const schoolHasUrn = (school) => school?.hasUrn === true;
